import {useQuery} from '@tanstack/react-query';

import {apiService} from '../apiService';
import {useAuth} from '../contexts/AuthContext';

export const employeeProfileQueryKey = (uid) => ['employeeProfile', uid];

const PROFILE_POLL_INTERVAL_MS = 60_000;

export const useEmployeeProfile = () => {
  const {user} = useAuth();
  const uid = user?.uid;

  const query = useQuery({
    queryKey: employeeProfileQueryKey(uid),
    queryFn: async () => {
      const data = await apiService.get(`/api/get-employee?uid=${uid}`);
      return {
        employee_id: data?.employee_id ?? null,
        uid: data?.uid ?? null,
        first_name: data?.first_name ?? '',
        last_name: data?.last_name ?? '',
        email: data?.email ?? '',
        phone_number: data?.phone_number ?? '',
        org_id: data?.org_id ?? null,
        company_name: data?.company_name ?? '',
        company_code: data?.company_code ?? null,
      };
    },
    enabled: !!uid,
    refetchInterval: PROFILE_POLL_INTERVAL_MS,
    initialData: user
      ? {
          employee_id: user.employee_id ?? null,
          uid: user.uid ?? null,
          first_name: user.first_name ?? '',
          last_name: user.last_name ?? '',
          email: user.email ?? '',
          phone_number: user.phone_number ?? '',
          org_id: user.org_id ?? null,
          company_name: user.company_name ?? '',
          company_code: user.company_code ?? null,
        }
      : undefined,
  });

  return query;
};
